export default "__VITE_ASSET__ad893ada__"